/* Codebeans — scroll-driven highlight underline
   Codebeans ka exact algorithm (home + about dono behaviours)

   TOP-OF-PAGE  (about page jaisa) : pehle FULL, fir scroll par ghatti hai
   MID-PAGE     (home page jaisa)  : kam -> full (viewport center par) -> kam
*/
(function () {
  var TARGETS = [
    // home page heading — mid-page behaviour
    { title: '#codebeansEveryoneDesignsText', topOfPage: false },
    // about page heading — top-of-page behaviour (pehle full)
    { title: '#codebeansAboutEveryoneDesignsText', topOfPage: true }
  ];

  var WORD_SELECTOR = 'strong, b, .codebeans-highlight-word';
  var WORD_STAGGER = 120; // ms, fade-in gap
  var INJECT_CSS = true;  // false karo agar aapki CSS pehle se --underline-scale use karti hai

  function scoped(titleSel, suffix) {
    return WORD_SELECTOR.split(',').map(function (s) {
      return titleSel + ' ' + s.trim() + suffix;
    }).join(',');
  }

  function injectCSS() {
    if (!INJECT_CSS || document.getElementById('cb-underline-css')) return;
    var css = '';
    TARGETS.forEach(function (t) {
      css +=
        scoped(t.title, '') + '{' +
          'position:relative;display:inline-block;--underline-scale:0;' +
          'opacity:0;transform:translateY(.35em);will-change:opacity,transform;' +
          'transition:opacity .6s cubic-bezier(.22,1,.36,1),transform .6s cubic-bezier(.22,1,.36,1);' +
        '}' +
        scoped(t.title, '::before') + ',' + scoped(t.title, '::after') + '{' +
          'transform:scaleX(var(--underline-scale,0));transform-origin:left center;' +
          'opacity:var(--underline-scale,0);transition:none;will-change:transform,opacity;' +
        '}';
    });
    var s = document.createElement('style');
    s.id = 'cb-underline-css';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function initOne(cfg) {
    var title = document.querySelector(cfg.title);
    if (!title || title.dataset.cbUnderline === '1') return;

    var words = [].slice.call(title.querySelectorAll(WORD_SELECTOR));
    if (!words.length) return;

    title.dataset.cbUnderline = '1';

    var isTopOfPage = cfg.topOfPage;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var revealed = false, ticking = false;

    function apply(v) {
      words.forEach(function (w) {
        w.style.setProperty('--underline-scale', String(v));
      });
    }

    function reveal() {
      if (revealed) return;
      revealed = true;
      words.forEach(function (w, i) {
        w.style.transitionDelay = (i * WORD_STAGGER) + 'ms';
        w.style.opacity = '1';
        w.style.transform = 'none';
      });
    }

    if (reduce) { reveal(); apply(1); return; }

    function update() {
      ticking = false;

      var rect = title.getBoundingClientRect();
      var wh = window.innerHeight;
      var center = (rect.top + rect.bottom) / 2;
      var scale = 0;

      if (isTopOfPage) {
        // ---- ABOUT: pehle full, upar scroll hote hi fade out ----
        if (center > 0 && center < wh) {
          var fadeOutStart = wh * 0.3;
          if (center >= fadeOutStart) scale = 1;
          else scale = center / fadeOutStart;
        } else if (center <= 0) {
          scale = 0;
        } else {
          scale = 1;
        }
      } else {
        // ---- HOME: kam -> full (center par) -> kam ----
        var vpCenter = wh / 2;
        var zoneTop = wh * 0.2;
        var zoneBottom = wh * 0.8;

        if (center >= zoneTop && center <= zoneBottom) {
          if (center <= vpCenter) scale = (center - zoneTop) / (vpCenter - zoneTop);
          else scale = (zoneBottom - center) / (zoneBottom - vpCenter);
        } else if (center < zoneTop && center > 0) {
          scale = Math.max(0, center / zoneTop * 0.3);
        } else if (center > zoneBottom && center < wh) {
          scale = Math.max(0, (wh - center) / (wh - zoneBottom) * 0.3);
        }
      }

      scale = Math.max(0, Math.min(1, scale));

      if (rect.top < wh && rect.bottom > 0) reveal();
      apply(scale);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function init() {
    injectCSS();
    TARGETS.forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    TARGETS.forEach(function (t) {
      var el = document.querySelector(t.title);
      if (el) el.dataset.cbUnderline = '';
    });
    init();
  });
})();

/* Site cursors (assets/custom.css). Run once the page is idle, and again on
   hover for hover-only rules and content added later:
   - the browser's own `pointer` / `text` cursors (class rules such as
     `.x { cursor: pointer }`) become the custom hand / text "T";
   - non-clickable text (an element with visible text of its own, outside
     links, buttons, labels and form fields) gets the custom "T", unless
     it already shows a hand;
   - anything else on `default` / `auto` gets the custom arrow.
   `cursor: none` (the "view" follower cards) and touch screens are left alone. */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var CLICKABLE = 'a[href], button, [role="button"], summary, select, label, input, textarea, [contenteditable="true"], [onclick]';

  function hasOwnText(el) {
    for (var n = el.firstChild; n; n = n.nextSibling) {
      if (n.nodeType === 3 && /\S/.test(n.nodeValue)) return true;
    }
    return false;
  }

  // Text blocks count as a whole, so the gaps between styled words of a
  // heading (spans with no text between them) don't flick back to the arrow.
  var TEXT_BLOCK = 'h1, h2, h3, h4, h5, h6, p, li, dt, dd, blockquote, figcaption, address, td, th';

  function isPlainText(el) {
    var text = hasOwnText(el) || (el.matches(TEXT_BLOCK) && /\S/.test(el.textContent));
    return text && !el.closest(CLICKABLE) && !el.closest('svg');
  }

  function set(el, name) {
    el.style.setProperty('cursor', 'var(--cb-cursor-' + name + ')', 'important');
  }

  function swap(el) {
    var cursor = getComputedStyle(el).cursor;
    if (cursor === 'pointer') return set(el, 'hand');
    if (cursor === 'text') return set(el, 'text');
    // The custom arrow (inherited from <html>) or the browser's default/auto.
    var arrow = cursor === 'default' || cursor === 'auto' || cursor.indexOf('L25 21.5Z') !== -1;
    if (!arrow) return;
    if (isPlainText(el)) set(el, 'text');
    else if (cursor === 'default' || cursor === 'auto') set(el, 'arrow');
  }

  function swapAll() {
    var all = document.body.getElementsByTagName('*');
    for (var i = 0; i < all.length; i++) swap(all[i]);
  }

  document.addEventListener(
    'mouseover',
    function (e) {
      if (e.target instanceof Element) swap(e.target);
    },
    { passive: true }
  );

  var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 200); };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { idle(swapAll); });
  } else {
    idle(swapAll);
  }
})();
